<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  count: { type: Number, default: 0 },
});

const { t } = useI18n();
</script>

<template>
  <div class="contents">
    <span
      v-if="props.count > 0"
      class="inline-flex w-fit rounded-full border border-red-200 bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700"
      data-test="review-correction-count"
    >
      {{
        t('SALES.REVIEW.RETURN_FORM.CORRECTION_COUNT', {
          count: props.count,
        })
      }}
    </span>
  </div>
</template>
